// extracted by mini-css-extract-plugin
module.exports = {"promoCodeLabel":"PromoCodeLabel__promoCodeLabel___1ymXl"};